import { Checkbox, Flex, Text } from '@servicetitan/anvil2';
import { DisclosureText } from './DisclosureText';
import { useState } from 'react';
import {
    ElectronicRecordsDisclosureDrawer,
    GeneralApplicationDisclosuresDrawer,
} from './NoticeDrawers';
import { DisclosureDataStore } from './DisclosureStore';
import { useTurnsIntegration, useProviderConfig } from '@servicetitan/financing-workflow-shared';
import { TurnsCoapplicationDisclosure } from './TurnsCoapplicationDisclosure';

export const Container = () => {
    const [openedNotice, setOpenedNotice] = useState<
        'ElectronicRecordsDisclosure' | 'GeneralApplicationDisclosure' | null
    >(null);
    const { setAgreedToDisclosures, setApplicantSignature, setCoApplicantSignature } =
        DisclosureDataStore.useStore();
    const { mustAgreeToMultipleDisclosures, turnsCoapplicationDisclosureText } =
        useProviderConfig();
    const turnsIntegration = useTurnsIntegration();

    const [agreedToGeneralDisclosures, setAgreedToGeneralDisclosures] = useState(false);
    // Only require Turns co-application disclosure when there's actual text to show (waterfall scenarios)
    const requireTurnsDisclosure = turnsIntegration.isEnabled && !!turnsCoapplicationDisclosureText;
    const [agreedToTurnsDisclosures, setAgreedToTurnsDisclosures] =
        useState(!requireTurnsDisclosure);

    const onGeneralDisclosureChange = (attested: boolean) => {
        setAgreedToGeneralDisclosures(attested);
        setAgreedToDisclosures(attested && agreedToTurnsDisclosures);
    };

    const onTurnsDisclosureChange = (attested: boolean) => {
        setAgreedToTurnsDisclosures(attested);
        setAgreedToDisclosures(attested && agreedToGeneralDisclosures);
    };

    return (
        <Flex direction="column" gap="6">
            <DisclosureText
                onOpenNotice={setOpenedNotice}
                onDisclosureChange={onGeneralDisclosureChange}
                onApplicantSignatureChange={setApplicantSignature}
                onCoApplicantSignatureChange={setCoApplicantSignature}
            />
            {openedNotice === 'ElectronicRecordsDisclosure' ? (
                <ElectronicRecordsDisclosureDrawer onClose={() => setOpenedNotice(null)} />
            ) : openedNotice === 'GeneralApplicationDisclosure' ? (
                <GeneralApplicationDisclosuresDrawer onClose={() => setOpenedNotice(null)} />
            ) : null}
            {!mustAgreeToMultipleDisclosures && (
                <Flex direction="column">
                    <Text>
                        <strong>Disclosure Agreement</strong>
                    </Text>
                    <Checkbox
                        label="I agree to the above disclaimers"
                        onChange={(e, state) => onGeneralDisclosureChange(state?.checked ?? false)}
                    />
                </Flex>
            )}
            {requireTurnsDisclosure && (
                <TurnsCoapplicationDisclosure onChange={onTurnsDisclosureChange} />
            )}
        </Flex>
    );
};
